import { AvContent } from "./AvContent";

let singleton: EntryRule | undefined;

export class EntryRule {
  /*               */
  private constructor(readonly rule: string) {}

  /*                  */

  static instance() {
    if (!singleton) {
      const rule = EntryRule.entryRule;
      if (rule) {
        singleton = new EntryRule(rule);
      }
    }
    return singleton;
  }

  /*                       */

  static get entryRule() {
    return EntryRule.historyRule || AvContent.pageRule();
  }

  private static get historyRule(): string | undefined {
    return window.history.state?.entryRule;
  }
}
